import { render, staticRenderFns } from "./IconSubscriptionStatus.vue?vue&type=template&id=71c4396a"
import script from "./IconSubscriptionStatus.vue?vue&type=script&lang=js"
export * from "./IconSubscriptionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports